import { Button } from '@components/ui/button';
import { ChevronRight } from 'lucide-react';

export default function FilterGroupSelector({
  setSelectedTab,
}: {
  setSelectedTab: (tab: 'contractDetails' | 'datapoints' | 'block-clause-details') => void;
}) {
  return (
    <div className="flex flex-col">
      {[
        {
          title: 'Contract Details',
          description: 'Core details like contract name, class, team and users',
          tabName: 'contractDetails' as const,
        },
        {
          title: 'Data Points',
          description: 'All structured data captured within the contract',
          tabName: 'datapoints' as const,
        },
        {
          title: 'Block & Clause Details',
          description: 'The blocks and clauses that make up the document',
          tabName: 'block-clause-details' as const,
        },
      ].map(({ title, description, tabName }) => (
        <Button
          key={tabName}
          variant="ghost"
          size="sm"
          className="flex h-auto cursor-auto flex-row items-center justify-between rounded-none border-b border-gray-200 py-4 last:border-0 has-[>svg]:px-3"
          onClick={() => setSelectedTab(tabName)}
        >
          <div className="flex min-w-0 flex-col items-start">
            <p className="font-bold">{title}</p>
            <p className="truncate text-xs leading-4 font-normal text-gray-600">{description}</p>
          </div>
          <ChevronRight className="size-4 shrink-0" />
        </Button>
      ))}
    </div>
  );
}
